<template>
    <div>
        <br/>
        <block v-if="loading"></block>

        <div class="background rounded-lg white">
            <div class="mt-2">
                <GeneralFilter
                    class="mt-0"
                    :breakline="true"
                    :filterEndpoint="$API.invoices.getImportedSalesHistory"
                    :columnsFilterEndpoint="$API.invoices.getImportedSalesHistory"
                    :search="{ ...this.filter, showAllRecords: this.showAllRecords }"
                    :columns.sync="filterColumns"
                    :advancedFilter="true"
                    prefix-column
                    @emptyFilter="clearFilter"
                    @filtered="filterHandler"
                    :isAutoScrolled="true"
                    @loading="changeLoading"
                    :showBranchSelector="true"
                    :showAllRecordsToggle="true"
                    :selectedBranch="selectedBranch"
                    :branches="branches"
                    :currentBranch="currentBranch"
                    @onBranchChange="onBranchChange"
                    :showAllRecords="showAllRecords"
                    @onShowAllRecordsChange="onShowAllRecordsChange"
                >
                    <v-row class="mx-3 mt-3 mb-0" align="center">
                        <v-col cols="12" class="d-flex justify-end">
                            <v-btn
                                color="error"
                                :disabled="selectedInvoiceIds.length === 0 || loading"
                                @click="deleteSelectedImportedInvoicesConfirm"
                            >
                                <v-icon left>mdi-delete</v-icon>
                                Eliminar seleccionadas
                            </v-btn>
                        </v-col>
                    </v-row>

                    <div class="resumen-estados mx-3 mt-3">
                        <div class="estado-item total">
                            TOTAL: {{ totalRegistros }}
                        </div>

                        <div
                            v-for="(cantidad, estado) in conteoPorEstado"
                            :key="estado"
                            class="estado-item"
                            :class="estado.replace(' ', '_')"
                        >
                            {{ estado }}: {{ cantidad }}
                        </div>
                    </div>

                    <DxDataGrid
                        :data-source="invoices"
                        key-expr="ID_Invoice"
                        @exporting="onExporting"
                        @row-prepared="onRowPrepared"
                        :scrolling="{ useNative: true }"
                        :column-auto-width="true"
                        :paging="{ enabled: false }"
                        :selected-row-keys="selectedInvoiceIds"
                        style="max-height: 600px;"
                        @selection-changed="onSelectionChanged"
                    >
                        <DxExport :enabled="true"/>
                        <DxSelection mode="multiple" show-check-boxes-mode="always" />
                        <!--DxColumn :width="50" cell-template="show-template" caption="" :fixed="true" fixed-position="left"></DxColumn-->
                        <DxColumn :width="50" cell-template="delete-template" caption="" :fixed="true" fixed-position="left"></DxColumn>
                        <DxColumn data-field="ID_Invoice" caption="ID" width="165px" :fixed="!isMobile" :fixed-position="!isMobile ? 'left' : undefined"></DxColumn>
                        <DxColumn v-if="ShowCorrelativeControl" cell-template="correlative-idinvoice" caption="Correlativo interno"></DxColumn>
                        <DxColumn data-field="InvoiceDate" width="120px" caption="Fecha del comprobante"></DxColumn>
                        <DxColumn data-field="hora" width="90px" caption="Hora"></DxColumn>
                        <DxColumn data-field="TipoDocumento" caption="Tipo de Documento"></DxColumn>
                        <DxColumn data-field="ID_Customer" width="180px" caption="ID de Cliente o Negocio"></DxColumn>
                        <DxColumn data-field="InvoiceName" caption="Nombre legal"></DxColumn>
                        <DxColumn data-field="InvoiceTotalPagarToShow" caption="Total de Factura"></DxColumn>
                        <DxColumn data-field="InvoiceStatusDescription" caption="Forma de pago"></DxColumn>
                        <DxColumn data-field="FeMhEstado" width="150px" caption="Estado"></DxColumn>
                        <DxColumn data-field="AmbienteToShow" width="150px" caption="Ambiente"></DxColumn>
                        <DxColumn data-field="CodigoGeneracion" caption="Codigo Generación"></DxColumn>
                        <DxColumn data-field="NumeroControl" caption="Numero de Control"></DxColumn>
                        <DxColumn data-field="FullName" caption="Usuario"></DxColumn>
                        <DxColumn data-field="FullNameSeller" caption="Vendedor"></DxColumn>
                        <DxColumn data-field="SelloRecepcion" caption="Sello Recepcion"></DxColumn>

                        <template #show-template="{data}">
                            <a href="#" class="mx-1" @click.prevent.stop="showInvoiceDetail(data)">
                                <v-icon color="primary">mdi-eye</v-icon>
                            </a>
                        </template>

                        <template #delete-template="{data}">
                            <a href="#" class="mx-1" @click.prevent.stop="deleteImportedInvoiceConfirm(data)">
                                <v-icon color="error">mdi-delete</v-icon>
                            </a>
                        </template>

                        <template #correlative-idinvoice="{data}">
                            {{ data.data.Correlative_ID_Invoice ? data.data.InvoiceType + "-" + data.data.Correlative_ID_Invoice : "" }}
                        </template>
                    </DxDataGrid>
                </GeneralFilter>
            </div>
        </div>

        <v-dialog v-model="showModal" scrollable max-width="75%">
            <v-card v-if="showInvoice">
                <invoice-details
                    :hasPrintButtom="true"
                    :hasUpdateCustomerBtn="false"
                    @close="showModal = false;"
                    :invoice="showInvoice.data"
                    :key="showInvoice.data.ID_Invoice"
                ></invoice-details>
            </v-card>
        </v-dialog>

        <alerts
            style="z-index: 20000 !important;"
            v-if="alert.show"
            v-on:close_alert="closeAlert"
            v-on:accept_alert="acceptAlert"
            :properties="alert"
        >
        </alerts>
    </div>
</template>

<script>
import { DxDataGrid, DxColumn, DxExport, DxSelection } from 'devextreme-vue/data-grid';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';
import { exportDataGrid } from 'devextreme/excel_exporter';
import InvoiceDetails from "../../invoices/InvoiceDetails";
import Block from "@/components/Block";
import Alerts from "@/components/Alerts";
import GeneralFilter from "../../../components/GeneralFilter.vue";
import { numberWithCommas } from '../../../helpers/money';

export default {
    name: "ImportedSalesHistory",
    components: {
        InvoiceDetails,
        DxDataGrid,
        DxColumn,
        DxExport,
        DxSelection,
        Block,
        Alerts,
        GeneralFilter,
    },
    data() {
        const user = JSON.parse(localStorage.getItem("user"));

        return {
            loading: false,
            invoices: [],
            showModal: false,
            showInvoice: null,
            invoiceToDelete: null,
            selectedInvoiceIds: [],
            selectedBranch: null,
            branches: [],
            currentBranch: null,
            showAllRecords: false,
            filter: {
                filter: '',
                codPointSale: localStorage.getItem("codPointSale"),
                ID_Branch: user.branch || "",
                ID_Business: user.businessid || "",
                user: user.id || "",
                istemplate: 0,
                showFNS: this.$store.getters['rolesUser/getCustomRole'](247) ? true : false,
            },
            alert: {
                type: "success",
                show: false,
                header: "",
                body: "",
                options: null,
            },
            filterColumns: [
                {
                    name: "IH.ID_Invoice",
                    title: 'ID de Factura',
                    value: '',
                },
                {
                    name: "CodigoGeneracion",
                    title: 'Código de generación',
                    value: '',
                },
                {
                    name: "NumeroControl",
                    title: 'Número de control',
                    value: '',
                },
                {
                    name: "CONCAT(TRIM(SU.FirstName), ' ', TRIM(SU.LastName))",
                    title: 'Usuario',
                    value: '',
                },
                {
                    name: "CONCAT(TRIM(SS.FirstName), ' ', TRIM(SS.LastName))",
                    title: 'Vendedor',
                    value: '',
                },
                {
                    name: "ID_Customer",
                    title: 'ID de Cliente',
                    value: '',
                },
                {
                    name: "InvoiceName",
                    title: 'Nombre Legal',
                    value: '',
                },
                {
                    name: "Valores",
                    title: 'Tipo de Documento',
                    value: '',
                    type: 'select',
                    options: [
                        { name: 'CONSUMIDOR FINAL', value: 'CONSUMIDOR FINAL' },
                        { name: 'CRÉDITO FISCAL', value: 'CRÉDITO FISCAL' },
                        { name: 'SUJETO EXCLUIDO', value: 'SUJETO EXCLUIDO' },
                        { name: 'EXPORTACIÓN', value: 'EXPORTACIÓN' },
                        { name: 'COMPROBANTE DE DONACIÓN', value: 'COMPROBANTE DE DONACIÓN' },
                        { name: 'NOTA DE CRÉDITO', value: 'NOTA DE CRÉDITO' }
                    ]
                },
                {
                    name: "startDate",
                    title: "Fecha Inicio",
                    value: "",
                    type: "date"
                },
                {
                    name: "endDate",
                    title: "Fecha Fin",
                    value: "",
                    type: "date"
                }
            ],
            ShowCorrelativeControl: user.showcorrelativecontrol,
            InvoiceTypeText: {
                "FCF": "FACTURA CONSUMIDOR FINAL",
                "CCF": "COMPROBANTE CRÉDITO FISCAL",
                "FNS": "FACTURA SUJETO EXCLUIDO",
                "FEX": "FACTURA EXPORTACIÓN",
                "CDD": "COMPROBANTE DE DONACION",
                "DNC": "NOTA DE CRÉDITO",
                "DND": "NOTA DE DÉBITO",
                "DNR": "NOTA DE REMISIÓN",
                "DCL": "DOCUMENTO CONTABLE DE LIQUIDACIÓN",
            }
        }
    },
    watch: {
        showModal() {
            if (!this.showModal) this.showInvoice = null;
        },
        selectedBranch() {
            if (this.selectedBranch) {
                this.filter.ID_Branch = this.selectedBranch;
            } else {
                this.filter.ID_Branch = JSON.parse(localStorage.getItem("user")).branch || "";
            }
        },
    },
    computed: {
        isMobile() {
            return this.$vuetify.breakpoint.mdAndDown;
        },
        conteoPorEstado() {
            const estados = {};

            if (this.invoices) {
                this.invoices.forEach(row => {
                    const estado = row.FeMhEstado || 'SIN ESTADO';
                    estados[estado] = (estados[estado] || 0) + 1;
                });
            }

            return estados;
        },
        totalRegistros() {
            return this.invoices?.length || 0;
        }
    },
    mounted() {
        this.getBranches();
        this.getAllInvoices();
    },
    methods: {
        onRowPrepared(e) {
            if (e.rowType !== 'data') return;

            const estado = e.data.FeMhEstado;

            if (estado === 'RECHAZADO') {
                e.rowElement.classList.add('row-rechazado');
            } else if (estado === 'CONTINGENCIA') {
                e.rowElement.classList.add('row-contingencia');
            } else if (estado === 'INVALIDADO') {
                e.rowElement.classList.add('row-invalidado');
            }
        },
        changeLoading(response) {
            this.loading = response;
        },
        filterHandler(response) {
            this.invoices = [...response];
            this.formatInvoiceFields();
        },
        clearFilter() {
            this.getAllInvoices();
        },
        onSelectionChanged(event) {
            const visibleKeys = this.invoices.map(invoice => invoice.ID_Invoice);
            const hiddenSelectedKeys = this.selectedInvoiceIds.filter(key => !visibleKeys.includes(key));
            const visibleSelectedKeys = event.selectedRowKeys || [];

            this.selectedInvoiceIds = [...new Set([...hiddenSelectedKeys, ...visibleSelectedKeys])];
        },
        formatInvoiceFields() {
            const dictionary = {
                '00': "Prueba",
                '01': "Producción"
            };
            const branch = JSON.parse(localStorage.getItem('branch') || "{}");
            const Currency = branch.Currency || "$";

            for (const index in this.invoices) {
                const { IdentificacionHorEmi, InvoiceType, SystemDateInsert, IdentificacionTipoDteDesc } = this.invoices[index];
                const totalPagar = Number(this.invoices[index]?.InvoiceTotalPagar || 0);

                this.invoices[index].AmbienteToShow = dictionary[this.invoices[index].IdentificacionAmbiente] || dictionary[this.invoices[index].Ambiente] || "";
                this.invoices[index].InvoiceTotalPagarToShow = `${Currency}${numberWithCommas(totalPagar.toFixed(2))}`;

                if (InvoiceType === 'TCKS') {
                    this.invoices[index].hora = this.formatDateToHour(SystemDateInsert);
                    this.invoices[index].TipoDocumento = "TICKET";
                } else {
                    this.invoices[index].TipoDocumento = IdentificacionTipoDteDesc || this.InvoiceTypeText[this.invoices[index].InvoiceType] || "";
                    this.invoices[index].hora = IdentificacionHorEmi || this.invoices[index].hora || "";
                }
            }
        },
        formatDateToHour(data) {
            const completeDate = new Date(data);
            const hour = completeDate.getHours();
            const minutes = completeDate.getMinutes();
            const seconds = completeDate.getSeconds();

            return `${hour.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
        },
        async getAllInvoices() {
            this.loading = true;

            try {
                const filterWithLimit = {
                    ...this.filter,
                    showAllRecords: this.showAllRecords
                };

                const response = await this.$API.invoices.getImportedSalesHistory(filterWithLimit);
                this.invoices = response;
                this.formatInvoiceFields();
            } catch (error) {
                this.showAlert(
                    "danger",
                    "Error",
                    error?.message || "Ha ocurrido un error al consultar el historial de ventas importadas."
                );
            } finally {
                this.loading = false;
            }
        },
        onExporting(e) {
            const workbook = new Workbook();
            const worksheet = workbook.addWorksheet('VentasImportadas');

            exportDataGrid({
                component: e.component,
                worksheet,
                topLeftCell: { row: 4, column: 1 },
            }).then((cellRange) => {
                const headerRow = worksheet.getRow(2);
                headerRow.height = 30;
                worksheet.mergeCells(2, 1, 2, 8);

                headerRow.getCell(1).value = 'Historial de Ventas Importadas';
                headerRow.getCell(1).font = { name: 'Segoe UI Light', size: 22 };
                headerRow.getCell(1).alignment = { horizontal: 'center' };

                const footerRowIndex = cellRange.to.row + 2;
                const footerRow = worksheet.getRow(footerRowIndex);
                worksheet.mergeCells(footerRowIndex, 1, footerRowIndex, 8);

                footerRow.getCell(1).value = '-';
                footerRow.getCell(1).font = { color: { argb: 'BFBFBF' }, italic: true };
                footerRow.getCell(1).alignment = { horizontal: 'right' };
            }).then(() => {
                workbook.xlsx.writeBuffer().then((buffer) => {
                    saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'HistorialVentasImportadas.xlsx');
                });
            });
            e.cancel = true;
        },
        showInvoiceDetail(data) {
            data.data.IsNDorNC = false;
            this.showInvoice = data;
            this.showModal = true;
        },
        deleteImportedInvoiceConfirm(data) {
            this.invoiceToDelete = data.data;
            this.showAlert(
                'strictValidation',
                'Eliminar factura importada',
                '¿Está seguro de proceder con la eliminación física de esta factura importada?',
                {
                    strictValidation: false,
                    strictValidationLabel: 'Entiendo que esta acción es irreversible y confirmo que deseo borrar esta factura importada.',
                    callbackLabel: 'deleteImportedInvoice'
                }
            );
        },
        async deleteImportedInvoice() {
            if (!this.invoiceToDelete?.ID_Invoice) return;

            this.loading = true;

            try {
                await this.$API.invoices.deleteImportedSaleInvoice(this.invoiceToDelete.ID_Invoice);
                this.selectedInvoiceIds = this.selectedInvoiceIds.filter(id => id !== this.invoiceToDelete.ID_Invoice);
                await this.getAllInvoices();
                this.showAlert(
                    "success",
                    "Factura importada eliminada",
                    "La factura importada se eliminó correctamente."
                );
            } catch (error) {
                this.showAlert(
                    "warning",
                    "No fue posible eliminar la factura importada",
                    error?.message || "Ha ocurrido un error al eliminar la factura importada."
                );
            } finally {
                this.invoiceToDelete = null;
                this.loading = false;
            }
        },
        deleteSelectedImportedInvoicesConfirm() {
            if (this.selectedInvoiceIds.length === 0) return;

            this.showAlert(
                'strictValidation',
                'Eliminar facturas importadas',
                `¿Está seguro de proceder con la eliminación física de ${this.selectedInvoiceIds.length} facturas importadas seleccionadas?`,
                {
                    strictValidation: false,
                    strictValidationLabel: 'Entiendo que esta acción es irreversible y confirmo que deseo borrar las facturas importadas seleccionadas.',
                    callbackLabel: 'deleteSelectedImportedInvoices'
                }
            );
        },
        async deleteSelectedImportedInvoices() {
            if (this.selectedInvoiceIds.length === 0) return;

            const invoiceIds = [...this.selectedInvoiceIds];
            this.loading = true;

            try {
                await this.$API.invoices.deleteImportedInvoices(invoiceIds);
                this.selectedInvoiceIds = this.selectedInvoiceIds.filter(id => !invoiceIds.includes(id));
                await this.getAllInvoices();
                this.showAlert(
                    "success",
                    "Facturas importadas eliminadas",
                    "Las facturas importadas seleccionadas se eliminaron correctamente."
                );
            } catch (error) {
                this.showAlert(
                    "warning",
                    "No fue posible eliminar las facturas importadas",
                    error?.message || "Ha ocurrido un error al eliminar las facturas importadas seleccionadas."
                );
            } finally {
                this.loading = false;
            }
        },
        closeAlert() {
            this.alert.show = false;
        },
        acceptAlert() {
            this.alert.show = false;

            if (!this.alert.options) return;

            const callbackLabel =
                typeof this.alert.options === 'object'
                    ? this.alert.options.callbackLabel
                    : this.alert.options;

            if (callbackLabel && typeof this[callbackLabel] === 'function') {
                this[callbackLabel]();
            }
        },
        showAlert(type, header, body, options = null) {
            this.alert.type = type == null ? "danger" : type;
            this.alert.header = header;
            this.alert.body = body;
            this.alert.show = true;
            this.alert.options = options != null ? options : null;
        },
        getBranches() {
            this.$API.branches
                .findBranches(JSON.parse(localStorage.getItem("user")).businessid)
                .then((data) => {
                    this.branches = data;

                    const currentUserBranch = JSON.parse(localStorage.getItem("user")).branch || "";
                    this.selectedBranch = currentUserBranch;
                    this.filter.ID_Branch = currentUserBranch;

                    const currentBranchData = data.find(branch => branch.ID_Branch == currentUserBranch);
                    if (currentBranchData) {
                        this.currentBranch = currentBranchData.BranchName;
                    }
                })
                .catch((err) => {
                    console.log("Error al obtener sucursales:", err);
                    this.$toasted.error("Error al cargar las sucursales");
                });
        },
        onBranchChange(e) {
            this.selectedBranch = e;

            if (this.selectedBranch) {
                const selectedBranchData = this.branches.find(branch => branch.ID_Branch == this.selectedBranch);
                if (selectedBranchData) {
                    this.currentBranch = selectedBranchData.BranchName;
                }
                this.filter.ID_Branch = this.selectedBranch;
            } else {
                const defaultBranch = JSON.parse(localStorage.getItem("user")).branch || "";
                this.selectedBranch = defaultBranch;
                this.filter.ID_Branch = defaultBranch;

                const defaultBranchData = this.branches.find(branch => branch.ID_Branch == defaultBranch);
                if (defaultBranchData) {
                    this.currentBranch = defaultBranchData.BranchName;
                }
            }
        },
        onShowAllRecordsChange(value) {
            this.showAllRecords = value;
        }
    }
}
</script>

<style scoped>
.resumen-estados {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
}

.estado-item {
    background: #f3f4f6;
    border-radius: 4px;
    color: #1f2937;
    font-weight: 600;
    padding: 6px 10px;
}

.estado-item.total {
    background: #1f2937;
    color: #fff;
}
</style>

<style>
.row-rechazado td {
    background-color: #ffe8e8 !important;
}

.row-contingencia td {
    background-color: #fff7d6 !important;
}

.row-invalidado td {
    background-color: #eeeeee !important;
}
</style>
